module.exports = __webpack_public_path__ + "static/media/submenu-usuarios.31b20264.svg";